exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".virt-player{position:relative;height:100%;width:100%;display:block}.virt-player img{max-width:100%}.virt-player:before{width:0;height:0;border-style:solid;border-width:8px 0 8px 15px;border-color:transparent transparent transparent #747475;margin-left:-4px;margin-top:-7px;z-index:10;opacity:.6}.virt-player:after,.virt-player:before{content:\"\";position:absolute;top:50%;left:50%}.virt-player:after{width:36px;height:36px;margin-top:-18px;margin-left:-18px;border-radius:50%;opacity:.7;background-color:#fff;z-index:1}.virt-player.error:after,.virt-player.error:before,.virt-player.error img,.virt-player .fake-play{display:none}.virt-player.error .fake-play{display:block}.virt-player .fake-play{height:70px;text-align:center;line-height:70px}.virt-player .fake-play>*{display:inline-block;white-space:nowrap}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/css-loader?minimize!/var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/site/root/css/iphone.css
// module id = 397
// module chunks = 4